import { coreEngine } from "@dinahmoe/dmafjs-core";
import { WebAudioNode } from "./node.js";

class WebAudioPingPongDelay extends WebAudioNode {
  namespace = "webaudio:node:pingPongDelay";
  handlers = {
    tempo: this.setTempo,
  };

  init(node) {
    const tempo = node.props.tempo;
    const subDivision = node.props.subDivision;

    if (tempo && subDivision) {
      const delayTime = this.tempoToTime(tempo, subDivision);
      coreEngine.update({
        uid: node.uid,
        key: "delayTime",
        value: delayTime,
      });
    }

    super.init(node);
  }

  setTempo(node) {
    const delayTime = this.tempoToTime(
      node.props.tempo,
      node.props.subDivision
    );
    coreEngine.update({
      uid: node.uid,
      key: "delayTime",
      value: delayTime,
    });
  }

  tempoToTime(tempo, subDivision) {
    const time = (60 / tempo) * 1000;

    switch (subDivision) {
      case "32":
        return time / 8;
      case "16T":
        return time / 6;
      case "32D":
        return (time * 3) / 16;
      case "16":
        return time / 4;
      case "8T":
        return time / 3;
      case "16D":
        return (time * 3) / 8;
      case "8":
        return time / 2;
      case "4T":
        return (time * 2) / 3;
      case "8D":
        return (time * 3) / 4;
      case "4":
        return time;
      case "2T":
        return (time * 4) / 3;
      case "4D":
        return (time * 3) / 2;
      case "2":
        return time * 2;
      case "2D":
        return time * 3;
      case "1":
        return time * 4;
      default:
        console.error("no match", tempo, subDivision);
    }
  }
}

const webAudioPingPongDelay = new WebAudioPingPongDelay();
export { webAudioPingPongDelay, WebAudioPingPongDelay };
